import { render, staticRenderFns } from "./carga_simple.vue?vue&type=template&id=7072ffd4&scoped=true"
import script from "./carga_simple.vue?vue&type=script&lang=js"
export * from "./carga_simple.vue?vue&type=script&lang=js"
import style0 from "./carga_simple.vue?vue&type=style&index=0&id=7072ffd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7072ffd4",
  null
  
)

export default component.exports